import React from "react";
import "./ProductDetail4.css";
import { Link } from "react-router-dom";
import Gfooter from "../Component/Gfooter";

function ProductDetail4() {
  return (
    <div className="toll-detail">

      {/* HERO */}
      <div className="toll-hero">
        {/* <img src="product-img/product4.jpg" alt="toll plaza" /> */}
        <video  className="toll-video" autoPlay loop muted playsInline>
          <source src="video/TPMS_video.mp4" type="video/mp4"/>
        </video>
        <div className="toll-overlay">
          <h1 data-aos="fade-up">Global Toll Plaza Management System</h1>
          <p data-aos="fade-up" data-aos-delay="100">
            Smart Toll Collection for Faster Highways 🚧
          </p>

          <div className="breadcrumb">
            <span>Home</span> ➝ <span>Products</span> ➝ <b>Toll Plaza</b>
          </div>
        </div>
      </div>

      {/* INTRO */}
      <div className="container toll-intro">
        <div className="row align-items-center">

          <div className="col-lg-6" data-aos="fade-right">
            <img
              src="project-pic/tollplazaimg.jpg"
              alt="toll system"
              className="img-fluid intro-img"
            />
          </div>

          <div className="col-lg-6" data-aos="fade-left">
            <h2>Enhancing Efficiency in Toll Collection</h2>
            <p>
              Global Toll Plaza Management System is an advanced solution
              designed to automate toll collection and improve traffic flow on
              highways.
            </p>
            <p>
              It ensures accurate transactions, reduces congestion, and enhances
              operational efficiency with smart automation and real-time data.
            </p>

            <Link to="/contact-us">
              <button className="demo-btn">Request Demo</button>
            </Link>
          </div>

        </div>
      </div>

      {/* FEATURES */}
      <div className="toll-features">
        <div className="container">
          <h2 className="section-title" data-aos="zoom-in">
            Key Features
          </h2>

          <div className="row">

            <div className="col-md-6 feature-box" data-aos="fade-up">
              <h4>Advanced Data Integration</h4>
              <p>
                Integrates real-time vehicle data and camera systems for
                accurate toll processing.
              </p>
            </div>

            <div className="col-md-6 feature-box" data-aos="fade-up" data-aos-delay="100">
              <h4>High Accuracy Recognition</h4>
              <p>
                Achieves up to 95–97% accuracy in vehicle identification.
              </p>
            </div>

            <div className="col-md-6 feature-box" data-aos="fade-up" data-aos-delay="200">
              <h4>Traffic Flow Optimization</h4>
              <p>
                Reduces congestion with automated toll processing and faster
                transactions.
              </p>
            </div>

            <div className="col-md-6 feature-box" data-aos="fade-up" data-aos-delay="300">
              <h4>Automated Reporting</h4>
              <p>
                Generates real-time reports for traffic, revenue, and system
                performance.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* BENEFITS */}
      <div className="toll-benefits">
        <div className="container">
          <h2 className="section-title" data-aos="zoom-in">
            Benefits
          </h2>

          <div className="row">

            <div className="col-md-6 benefit-card" data-aos="flip-left">
              <h4>Improved Efficiency</h4>
              <p>
                Faster toll collection reduces waiting time and improves flow.
              </p>
            </div>

            <div className="col-md-6 benefit-card" data-aos="flip-right">
              <h4>Enhanced Revenue Collection</h4>
              <p>
                Accurate billing ensures maximum revenue without leakage.
              </p>
            </div>

            <div className="col-md-6 benefit-card" data-aos="flip-left">
              <h4>Better User Experience</h4>
              <p>
                Smooth and quick transactions for drivers.
              </p>
            </div>

            <div className="col-md-6 benefit-card" data-aos="flip-right">
              <h4>Data Insights</h4>
              <p>
                Real-time analytics help in better decision-making.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="toll-cta">
        <h2 data-aos="zoom-in">Upgrade Your Toll System Today</h2>
        <p data-aos="fade-up">
          Experience faster highways with smart toll automation.
        </p>

        <Link to="/contact-us">
          <button className="cta-btn">Get Started</button>
        </Link>
      </div>

      <Gfooter />
    </div>
  );
}

export default ProductDetail4;

// import React, { useEffect, useRef, useState } from "react";
// import "./ProductDetail5.css";
// import { Link } from "react-router-dom";
// import Gfooter from "../Component/Gfooter";

// /* ─── Stat counter hook ─── */
// function useCounter(target, duration = 2000, start = false) {
//   const [count, setCount] = useState(0);
//   useEffect(() => {
//     if (!start) return;
//     let startTime = null;
//     const step = (timestamp) => {
//       if (!startTime) startTime = timestamp;
//       const progress = Math.min((timestamp - startTime) / duration, 1);
//       setCount(Math.floor(progress * target));
//       if (progress < 1) requestAnimationFrame(step);
//     };
//     requestAnimationFrame(step);
//   }, [start, target, duration]);
//   return count;
// }

// /* ─── Intersection observer hook ─── */
// function useInView(threshold = 0.2) {
//   const ref = useRef(null);
//   const [inView, setInView] = useState(false);
//   useEffect(() => {
//     const obs = new IntersectionObserver(
//       ([entry]) => { if (entry.isIntersecting) setInView(true); },
//       { threshold }
//     );
//     if (ref.current) obs.observe(ref.current);
//     return () => obs.disconnect();
//   }, [threshold]);
//   return [ref, inView];
// }

// /* ─── Single stat card ─── */
// function StatCard({ value, suffix, label, delay }) {
//   const [ref, inView] = useInView(0.3);
//   const count = useCounter(value, 2000, inView);
//   return (
//     <div className="stat-card" ref={ref} style={{ animationDelay: `${delay}ms` }}>
//       <span className="stat-number">{count}{suffix}</span>
//       <span className="stat-label">{label}</span>
//     </div>
//   );
// }

// /* ─── Feature card ─── */
// function FeatureCard({ icon, title, desc, img, delay, tag }) {
//   return (
//     <div className="feat-card" data-aos="fade-up" style={{ animationDelay: `${delay}ms` }}>
//       {tag && <span className="feat-tag">{tag}</span>}
//       <div className="feat-img-wrap">
//         <img src={img} alt={title} className="feat-img" />
//         <div className="feat-img-overlay" />
//       </div>
//       <div className="feat-content">
//         <span className="feat-icon">{icon}</span>
//         <h3 className="feat-title">{title}</h3>
//         <p className="feat-desc">{desc}</p>
//       </div>
//     </div>
//   );
// }

// /* ─── Process step ─── */
// function ProcessStep({ number, title, desc, icon, active }) {
//   return (
//     <div className={`process-step ${active ? "process-step--active" : ""}`}>
//       <div className="process-icon">{icon}</div>
//       <div className="process-num">{String(number).padStart(2, "0")}</div>
//       <h4 className="process-title">{title}</h4>
//       <p className="process-desc">{desc}</p>
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════ */
//  function ProductDetail4() {
//   const [heroLoaded, setHeroLoaded] = useState(false);
//   const [activeStep, setActiveStep] = useState(0);
//   const [statsRef, statsInView] = useInView(0.3);

//   /* cycle through process steps */
//   useEffect(() => {
//     const id = setInterval(() => setActiveStep((s) => (s + 1) % 5), 2500);
//     return () => clearInterval(id);
//   }, []);

//   /* hero loaded */
//   useEffect(() => {
//     const t = setTimeout(() => setHeroLoaded(true), 100);
//     return () => clearTimeout(t);
//   }, []);

//   const features = [
//     {
//       icon: "🎯",
//       title: "AI Vehicle Detection",
//       tag: "Core AI",
//       desc: "Real-time AI camera systems detect and classify every vehicle — cars, trucks, buses — with up to 99.8% accuracy using advanced computer vision models.",
//       img: "project-pic/feature-detection.jpg",
//       delay: 0,
//     },
//     {
//       icon: "📡",
//       title: "FASTag Integration",
//       tag: "RFID",
//       desc: "Seamless RFID-based FASTag reading across all lanes ensures frictionless electronic toll collection with instant payment verification and balance checks.",
//       img: "project-pic/feature-fastag.jpg",
//       delay: 100,
//     },
//     {
//       icon: "🚨",
//       title: "Fraud Detection Engine",
//       tag: "Security",
//       desc: "Multi-layer fraud intelligence flags invalid FASTag IDs, license plate mismatches, speed violations and suspicious activity in under 200 milliseconds.",
//       img: "project-pic/feature-fraud.jpg",
//       delay: 200,
//     },
//     {
//       icon: "📊",
//       title: "Live Operations Dashboard",
//       tag: "Analytics",
//       desc: "A centralised command dashboard delivers lane-level performance, revenue analytics, vehicle logs and AI camera feeds — all in one real-time view.",
//       img: "project-pic/dashboard.jpg",
//       delay: 300,
//     },
//     {
//       icon: "🖥️",
//       title: "Control Room Monitoring",
//       tag: "Operations",
//       desc: "Dedicated operator consoles give supervisors full visibility across every lane with multi-screen CCTV feeds, incident alerts and manual override controls.",
//       img: "project-pic/feature-monitoring.jpg",
//       delay: 400,
//     },
//     {
//       icon: "📋",
//       title: "Automated Reports",
//       tag: "Reporting",
//       desc: "Auto-generated PDF, CSV and XLS reports covering revenue, traffic throughput, fraud incidents and system health — scheduled or on-demand.",
//       img: "project-pic/reports.jpg",
//       delay: 500,
//     },
//   ];

//   const processSteps = [
//     { icon: "🚗", title: "Vehicle Approach", desc: "Vehicle enters the toll plaza detection zone; sensors and cameras activate automatically." },
//     { icon: "📷", title: "AI Camera Detection", desc: "High-speed AI camera captures the vehicle, classifies type and reads the license plate (LPR)." },
//     { icon: "🏷️", title: "FASTag / LPR Recognition", desc: "RFID reader scans the FASTag; LPR engine cross-validates the number plate in real time." },
//     { icon: "☁️", title: "Cloud Verification", desc: "Transaction data is matched against the cloud database for balance, blacklists and fraud rules." },
//     { icon: "✅", title: "Clearance & Dashboard", desc: "Boom barrier lifts on success; all data is timestamped and pushed to the live dashboard." },
//   ];

//   const benefits = [
//     { icon: "⚡", title: "21s Average Clearance", desc: "From vehicle arrival to boom-barrier lift in under 21 seconds — even at peak-hour volumes." },
//     { icon: "💰", title: "Zero Revenue Leakage", desc: "AI cross-validation of FASTag, plate and payment eliminates manual errors and bypass attempts." },
//     { icon: "🔒", title: "Bank-Grade Security", desc: "End-to-end encrypted transactions with multi-factor fraud rules and real-time alert escalation." },
//     { icon: "📈", title: "Scalable Architecture", desc: "Cloud-native design scales from a 2-lane booth to a 50-lane national highway corridor seamlessly." },
//     { icon: "🌐", title: "NHAI Compliant", desc: "Fully aligned with NHAI's FASTag ecosystem, ANPR standards and audit-ready reporting formats." },
//     { icon: "🤖", title: "Self-Learning AI", desc: "Models retrain on new vehicle types, lighting conditions and regional plates for continuous improvement." },
//   ];

//   return (
//     <div className="tpms-page">

//       {/* ── HERO ── */}
//       <section className="tpms-hero">
//         <video className="tpms-hero__video" autoPlay loop muted playsInline>
//           <source src="video/TPMS_video.mp4" type="video/mp4" />
//         </video>
//         <div className="tpms-hero__noise" />
//         <div className={`tpms-hero__overlay ${heroLoaded ? "tpms-hero__overlay--visible" : ""}`}>
//           <div className="tpms-hero__badge">
//             <span className="tpms-hero__badge-dot" />
//             AI-Powered · Real-Time · NHAI Compliant
//           </div>
//           <h1 className="tpms-hero__title">
//             Global Toll Plaza<br />
//             <span className="tpms-hero__title-accent">Management System</span>
//           </h1>
//           <p className="tpms-hero__subtitle">
//             Smart automation for India's highways — from FASTag verification<br className="d-none d-md-block" />
//             to fraud detection, every vehicle, every second.
//           </p>
//           <div className="tpms-hero__actions">
//             <Link to="/contact-us">
//               <button className="btn-primary">Request Demo</button>
//             </Link>
//             <a href="#tpms-flow" className="btn-ghost">See How It Works ↓</a>
//           </div>
//           <div className="tpms-hero__breadcrumb">
//             <span>Home</span>
//             <span className="tpms-hero__breadcrumb-sep">›</span>
//             <span>Products</span>
//             <span className="tpms-hero__breadcrumb-sep">›</span>
//             <b>TPMS</b>
//           </div>
//         </div>
//         {/* floating HUD badges */}
//         <div className="hud hud--tl">
//           <span className="hud__label">System Status</span>
//           <span className="hud__value hud__value--green">● OPERATIONAL</span>
//         </div>
//         <div className="hud hud--tr">
//           <span className="hud__label">AI Accuracy</span>
//           <span className="hud__value">98.9%</span>
//         </div>
//         <div className="hud hud--bl">
//           <span className="hud__label">Avg. Clearance</span>
//           <span className="hud__value">21s</span>
//         </div>
//       </section>

//       {/* ── STATS BAR ── */}
//       <div className="stats-bar" ref={statsRef}>
//         <StatCard value={99} suffix="%" label="AI Detection Accuracy" delay={0} />
//         <div className="stats-divider" />
//         <StatCard value={21} suffix="s" label="Avg. Lane Clearance" delay={150} />
//         <div className="stats-divider" />
//         <StatCard value={120} suffix="+" label="Vehicles / Hour / Lane" delay={300} />
//         <div className="stats-divider" />
//         <StatCard value={0} suffix="%" label="Revenue Leakage" delay={450} />
//         <div className="stats-divider" />
//         <StatCard value={24} suffix="/7" label="Live Monitoring" delay={600} />
//       </div>

//       {/* ── INTRO ── */}
//       <section className="tpms-intro">
//         <div className="tpms-container tpms-intro__inner">
//           <div className="tpms-intro__media">
//             <img
//               src="project-pic/Hero-Image.jpg"
//               alt="Toll plaza overview"
//               className="tpms-intro__img"
//             />
//             <div className="tpms-intro__img-glow" />
//             <div className="tpms-intro__chip tpms-intro__chip--1">
//               <span>●</span> All Lanes Active
//             </div>
//             <div className="tpms-intro__chip tpms-intro__chip--2">
//               <span>⚡</span> 98.9% Accuracy
//             </div>
//           </div>
//           <div className="tpms-intro__copy">
//             <p className="tpms-intro__eyebrow">NEXT-GENERATION TOLL AUTOMATION</p>
//             <h2 className="tpms-intro__heading">
//               Smarter Highways<br />Start Here
//             </h2>
//             <p className="tpms-intro__body">
//               GSUN TEC's Toll Plaza Management System combines deep-learning vehicle detection,
//               FASTag RFID verification and a real-time analytics dashboard into one unified platform
//               purpose-built for Indian national highways.
//             </p>
//             <p className="tpms-intro__body">
//               Whether you operate a 2-lane booth or a 24-lane expressway interchange, TPMS scales
//               seamlessly — reducing congestion, eliminating revenue leakage and giving operators
//               complete visibility from a single screen.
//             </p>
//             <ul className="tpms-intro__bullets">
//               <li>✓ NHAI &amp; IHMCL FASTag ecosystem compliant</li>
//               <li>✓ Deployable on existing hardware infrastructure</li>
//               <li>✓ Cloud-native with on-premise fallback</li>
//               <li>✓ White-labelled operator portal included</li>
//             </ul>
//             <Link to="/contact-us">
//               <button className="btn-primary">Request Demo</button>
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* ── FEATURES ── */}
//       <section className="tpms-features" id="tpms-features">
//         <div className="tpms-container">
//           <p className="section-eyebrow">CAPABILITIES</p>
//           <h2 className="section-heading">
//             Everything Your Toll Plaza<br />
//             <span className="text-accent">Needs to Perform</span>
//           </h2>
//           <p className="section-subhead">
//             Six AI-powered modules, one integrated platform — covering detection, payment, fraud, monitoring, reporting and analytics.
//           </p>
//           <div className="feat-grid">
//             {features.map((f) => (
//               <FeatureCard key={f.title} {...f} />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── PROCESS FLOW ── */}
//       <section className="tpms-flow" id="tpms-flow">
//         <div className="tpms-container">
//           <p className="section-eyebrow">HOW IT WORKS</p>
//           <h2 className="section-heading">
//             From Approach to Clearance<br />
//             <span className="text-accent">in 5 Intelligent Steps</span>
//           </h2>
//           <div className="flow-visual">
//             <img src="project-pic/flow.jpg" alt="System flow diagram" className="flow-img" />
//             <div className="flow-img-overlay" />
//           </div>
//           <div className="process-steps">
//             {processSteps.map((s, i) => (
//               <ProcessStep key={i} number={i + 1} {...s} active={activeStep === i} />
//             ))}
//           </div>
//           <div className="flow-connector">
//             {processSteps.map((_, i) => (
//               <React.Fragment key={i}>
//                 <div className={`flow-dot ${activeStep === i ? "flow-dot--active" : ""}`} />
//                 {i < processSteps.length - 1 && (
//                   <div className={`flow-line ${activeStep > i ? "flow-line--done" : ""}`} />
//                 )}
//               </React.Fragment>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── BENEFITS ── */}
//       <section className="tpms-benefits">
//         <div className="tpms-container">
//           <p className="section-eyebrow">WHY TPMS</p>
//           <h2 className="section-heading">
//             Built for Results,<br />
//             <span className="text-accent">Designed for Scale</span>
//           </h2>
//           <div className="benefits-grid">
//             {benefits.map((b, i) => (
//               <div className="benefit-item" key={i} style={{ animationDelay: `${i * 100}ms` }}>
//                 <div className="benefit-icon">{b.icon}</div>
//                 <h4 className="benefit-title">{b.title}</h4>
//                 <p className="benefit-desc">{b.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── DASHBOARD SHOWCASE ── */}
//       <section className="tpms-showcase">
//         <div className="tpms-container tpms-showcase__inner">
//           <div className="tpms-showcase__copy">
//             <p className="section-eyebrow">LIVE DASHBOARD</p>
//             <h2 className="section-heading">
//               Every Lane.<br />
//               Every Vehicle.<br />
//               <span className="text-accent">One Screen.</span>
//             </h2>
//             <p className="tpms-intro__body">
//               The TPMS command dashboard aggregates vehicle counts, revenue breakdowns,
//               FASTag utilisation stats, lane performance timings and AI camera feeds into
//               a single, operator-friendly interface — updated every second.
//             </p>
//             <ul className="tpms-intro__bullets">
//               <li>✓ Real-time vehicle log with AI accuracy scores</li>
//               <li>✓ One-click PDF / CSV / XLS report export</li>
//               <li>✓ Multi-lane boom barrier status &amp; override</li>
//               <li>✓ Fraud alert escalation with audit trail</li>
//             </ul>
//             <Link to="/contact-us">
//               <button className="btn-primary">See Live Demo</button>
//             </Link>
//           </div>
//           <div className="tpms-showcase__media">
//             <img
//               src="project-pic/dashboard.jpg"
//               alt="TPMS Dashboard"
//               className="showcase-img"
//             />
//             <div className="showcase-frame" />
//           </div>
//         </div>
//       </section>

//       {/* ── CTA ── */}
//       <section className="tpms-cta">
//         <div className="tpms-cta__bg" />
//         <div className="tpms-cta__content">
//           <p className="section-eyebrow" style={{ color: "var(--clr-accent)" }}>GET STARTED</p>
//           <h2 className="tpms-cta__heading">
//             Ready to Upgrade Your<br />Toll Infrastructure?
//           </h2>
//           <p className="tpms-cta__sub">
//             Join highway operators across India using GSUN TEC's AI-powered TPMS
//             to collect more revenue, stop fraud and move traffic faster.
//           </p>
//           <div className="tpms-cta__actions">
//             <Link to="/contact-us">
//               <button className="btn-primary btn-primary--lg">Request Demo</button>
//             </Link>
//             <Link to="/contact-us">
//               <button className="btn-ghost btn-ghost--lg">Talk to an Expert</button>
//             </Link>
//           </div>
//         </div>
//       </section>

//       <Gfooter />
//     </div>
//   );
// }
// export default ProductDetail4;